import { render, staticRenderFns } from "./createForm.vue?vue&type=template&id=39d8da2a&scoped=true"
import script from "./createForm.vue?vue&type=script&lang=js"
export * from "./createForm.vue?vue&type=script&lang=js"
import style0 from "./createForm.vue?vue&type=style&index=0&id=39d8da2a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d8da2a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39d8da2a')) {
      api.createRecord('39d8da2a', component.options)
    } else {
      api.reload('39d8da2a', component.options)
    }
    module.hot.accept("./createForm.vue?vue&type=template&id=39d8da2a&scoped=true", function () {
      api.rerender('39d8da2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/compensationManagement/compensationList/components/createForm.vue"
export default component.exports